const canvas = document.createElement('canvas');
const context = canvas.getContext('2d');
context.font = '400 14px Nunito, sans-serif';

export const getTextWidth = function (text) {
    return context.measureText(text).width + 10;
};

export const isElementContainsClass = function (element, classes) {
    return classes.some((cssClass) => element.classList.contains(cssClass));
};

export const findElementIndexWithClass = function (element, cssClass) {
    const elements = element.children;
    for (let i = 0; i < elements.length; i++) {
        if (elements[i].classList.contains(cssClass)) {
            return i;
        }
    }
    return -1;
};

export const getNodeIndex = function (node) {
    return Array.prototype.indexOf.call(node.parentNode.childNodes, node);
};

export const deleteInlineStyle = function (element, styleName) {
    element.style.removeProperty(styleName);
};

export const deleteClass = function (element, className) {
    element.classList.remove(className);
};
export const deleteInlineStyles = function (element, styleNames) {
    styleNames.forEach((styleName) => {
        element.style.removeProperty(styleName);
    });
};
export const deleteCssRules = function (stylesObj) {
    if (stylesObj && stylesObj.cssRules) {
        const cssRulesLength = stylesObj.cssRules.length;
        for (let i = 0; i < cssRulesLength; i++) {
            stylesObj.deleteRule(0);
        }
    }
};

export const createCssRules = function (callback) {
    let stylesObj = '';
    const rules = callback();
    const style = document.createElement('style');
    style.appendChild(document.createTextNode(''));
    document.head.appendChild(style);
    stylesObj = style.sheet;
    rules.forEach((rule, ruleIndex) => {
        stylesObj.insertRule(rule, ruleIndex);
    });
    return stylesObj;
};

export const addCssRules = function (stylesObj, callback) {
    const rules = callback();
    rules.forEach((rule, ruleIndex) => {
        stylesObj.insertRule(rule, ruleIndex);
    });
    return stylesObj;
};

export const setInlineStyles = function (element, styles) {
    Object.entries(styles).forEach(([key, value]) => {
        element.style[key] = value;
    });
};

export const getElementsIndexesInRow = function (targetElement, allElements, excludeElements = []) {
    const elementBlockTop = targetElement.getBoundingClientRect().top;
    const indexes = [];
    Array.from(allElements).forEach((el, elIndex) => {
        if (excludeElements.every((exEl) => !exEl.isSameNode(el)) && el.getBoundingClientRect().top === elementBlockTop) {
            indexes.push(elIndex);
        }
    });
    return indexes;
};

export const getElementsRowIndex = function (targetElement, allElements) {
    const elementBlockTop = targetElement.getBoundingClientRect().top;
    const offsets = [];
    Array.from(allElements).forEach((el) => {
        if (!offsets.includes(el.getBoundingClientRect().top)) {
            offsets.push(el.getBoundingClientRect().top);
        }
    });
    return offsets.findIndex((ofsset) => ofsset === elementBlockTop);
};

export const getElementsRowCoordinates = function (targetElement, allElements) {
    const elementBlockTop = targetElement.getBoundingClientRect().top;
    const offsets = [];
    Array.from(allElements).forEach((el) => {
        if (!offsets.includes(el.getBoundingClientRect().top)) {
            offsets.push(el.getBoundingClientRect().top);
        }
    });
    const currentRowIndex = offsets.findIndex((ofsset) => ofsset === elementBlockTop);
    const coordinates = {
        top: currentRowIndex > 0 ? offsets[currentRowIndex - 1] : null,
        current: offsets[currentRowIndex],
        bottom: currentRowIndex < offsets.length - 1 ? offsets[currentRowIndex + 1] : null,
    };
    return coordinates;
};

export const getElementIndexFromArray = function (targetElement, excludeElements) {
    let index = -1;
    const elements = Array.from(targetElement.parentNode.children).filter((element) => excludeElements.every((exEl) => !exEl.isSameNode(element)));
    elements.forEach((el, elIndex) => {
        if (el.isSameNode(targetElement)) {
            index = elIndex;
        }
    });
    return index;
};

export const generateAndCopyTableFromArray = function (rowsHtml) {
    const copytable = document.querySelector('#copy-table');
    copytable.innerHTML = `<table><tbody>${rowsHtml}</tbody></table>`;
    const range = document.createRange();
    const sel = window.getSelection();
    sel.removeAllRanges();
    range.selectNodeContents(copytable);
    sel.addRange(range);
    document.execCommand('Copy');
    copytable.innerHTML = '';
};

export const copyStringToClipboard = function (str) {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style = {position: 'absolute', left: '-9999px'};
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    // Remove temporary element
    document.body.removeChild(el);
};

export const removeSelection = function () {
    if (window.getSelection) {
        window.getSelection().removeAllRanges();
    } else if (document.selection) {
        document.selection.empty();
    }
};
export const getStylesDigitalProperty = function (querySelector, cssProperty) {
    return +window.getComputedStyle(document.querySelector('.page-body'), null).getPropertyValue(cssProperty).match(/\d+/)[0];
};
